/**
 * Carte de consentement de l'observatoire (PRD §13 ; docs/legal/confidentialite.md ; RUNBOOK-DEPLOY §8) : petite, claire,
 * décochée par défaut, réversible. Affichée seulement si l'API annonce la télémétrie (`/api/health` → `telemetry: true`).
 */
import { beliefsEnabled, hasConsent } from "../telemetry.js";

export function consentCard(): string {
  const on = hasConsent();
  return `<div class="card consent" id="consent-card">
    <label class="t"><input type="checkbox" data-consent ${on ? "checked" : ""}> Partager anonymement mes choix avec l'observatoire du jeu</label>
    <p class="hint">Facultatif, décoché par défaut. Si tu coches : les mesures choisies, les curseurs, le financement, tes réponses aux crises,
    le résultat et le texte de tes propositions sont envoyés pour des statistiques publiques agrégées. Pas de compte, pas de cookie,
    pas d'adresse IP conservée : un identifiant aléatoire oublié à la fermeture de l'onglet. Données brutes effacées après 90 jours.
    ${beliefsEnabled() ? "" : "Aucune question sur tes opinions n'est posée."} Tu peux décocher à tout moment : plus rien ne part.</p>
    <p class="hint" id="consent-status" aria-live="polite">${on ? "Merci : partage activé." : "Partage désactivé."}</p>
  </div>`;
}
